import { render, staticRenderFns } from "./SendDocumentOnEmail.vue?vue&type=template&id=01d2a807&scoped=true"
import script from "./SendDocumentOnEmail.vue?vue&type=script&lang=js"
export * from "./SendDocumentOnEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2a807",
  null
  
)

export default component.exports